import dynamic from 'next/dynamic';
import { FC } from 'react';
import { Button } from '@chakra-ui/react';
import { CoreBlock } from '../../types';

const ButtonLink = dynamic(() => import('../ButtonLink'));

export interface CoreButtonProps {
  block: CoreBlock & {
    attrs?: CoreBlock['attrs'] & {
      url?: string;
      label?: string;
      target?: '_self' | '_blank' | undefined;
      form?: string;
    };
    innerHTML?: string;
    innerBlocks?: any[];
  };
  size?: 'md' | 'lg';
}

const CoreButton: FC<CoreButtonProps> = ({ block, size, ...rest }) => {
  const { className, url, label, target = '_self', width } = block?.attrs || {};

  const variant = className?.includes('is-style-outline')
    ? 'outlineGreen'
    : 'solidGreen';

  const widthValue = width ? `${width}%` : 'auto';

  if (url) {
    return (
      <ButtonLink
        size={size}
        link={{
          url,
          title: label,
          target,
        }}
        sx={{
          '.chakra-button &': {
            width: width ? widthValue : 'auto',
            maxWidth: width ? 'none' : 'inherit',
          },
        }}
        variant={variant}
        {...rest}
      />
    );
  }

  return label ? (
    <Button
      variant={variant}
      size={size}
      width={widthValue}
      maxWidth={width ? 'none' : 'inherit'}
      {...rest}
    >
      {label}
    </Button>
  ) : null;
};

export default CoreButton;
